import React from 'react';

import { LoaderStyled } from './styles';

const Loader = React.memo(() => (
  <LoaderStyled>
    <span />
    <span />
    <span />
    <span />
    <span />
  </LoaderStyled>
));

export default Loader;
